import Tabs from "@/components/Tabs";
import AppLayout from "@/layouts/AppLayout";
import PageHeading from "@/components/PageHeading";
import { useNavigate } from "@/router";
import type { Path } from "@/router";
import { useLocation } from "react-router-dom";

export default function TabLayout({ children }: { children: React.ReactNode }) {
  const location = useLocation();

  const { pathname } = location;
  const navigate = useNavigate();

  const items = [
    {
      label: "Events",
      to: "/activities/events" as const
    },
    {
      label: "PDR Activity Types",
      to: "/activities/activity-types" as const
    }
  ];

  return (
    <AppLayout>
      <PageHeading title="Activities" />
      <Tabs
        tabItems={items.map(({ label, to }) => ({
          label,
          onClick: () => navigate(to as Path),
          active: (pathname.endsWith("/") ? pathname.slice(0, -1) : pathname) === to
        }))}
      />

      <div className="flex flex-col">{children}</div>
    </AppLayout>
  );
}
